import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Emoji from "../Emoji";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Loader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Loader, _React$PureComponent);
  var _super = _createSuper(Loader);
  function Loader() {
    var _this;
    _classCallCheck(this, Loader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getAnimationStyle", function () {
      return _this.props.active && {
        animationIterationCount: 'infinite',
        animationName: cx('sliding'),
        animationDuration: "".concat(_this.props.children.length * _this.props.timeout, "ms"),
        animationTimingFunction: "steps(".concat(_this.props.children.length, ", end)")
      } || null;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
        active = _this$props.active,
        size = _this$props.size,
        className = _this$props.className,
        children = _this$props.children,
        lastIcon = _this$props.lastIcon;
      var done = !active;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('loaderWrapper', size, className, {
          active: active,
          done: done
        }),
        "data-t-id": "components-Loader"
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('loader')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('projector')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('film'),
        style: _this.getAnimationStyle()
      }, children.map(function (icon, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx('slide'),
          key: index
        }, icon);
      }))), /*#__PURE__*/React.createElement("div", {
        className: cx('highlight')
      })), /*#__PURE__*/React.createElement("div", {
        className: cx('lastIcon')
      }, lastIcon));
    });
    return _this;
  }
  return _createClass(Loader);
}(React.PureComponent);
_defineProperty(Loader, "defaultProps", {
  size: null,
  className: null,
  timeout: 250
});
Loader.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  size: PropTypes.oneOf(['big', 'small']),
  className: PropTypes.string,
  active: PropTypes.bool.isRequired,
  lastIcon: PropTypes.node.isRequired,
  timeout: PropTypes.number
} : {};
var _default = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(_default, _React$PureComponent2);
  var _super2 = _createSuper(_default);
  function _default() {
    var _this2;
    _classCallCheck(this, _default);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "render", function () {
      return /*#__PURE__*/React.createElement(Loader, {
        active: _this2.props.status === 'active',
        lastIcon: /*#__PURE__*/React.createElement(Emoji, {
          name: _this2.props.lastIcon
        }),
        size: _this2.props.size,
        timeout: 250
      }, _this2.props.icons.map(function (name) {
        return /*#__PURE__*/React.createElement(Emoji, {
          key: name,
          name: name
        });
      }));
    });
    return _this2;
  }
  return _createClass(_default);
}(React.PureComponent);
_defineProperty(_default, "propTypes", {
  icons: PropTypes.array,
  status: PropTypes.string,
  size: PropTypes.string,
  lastIcon: PropTypes.string
});
_defineProperty(_default, "defaultProps", {
  icons: ['chat', 'clock', 'infinitCalls', 'simOrder', 'infinitInternet'],
  status: 'ready',
  lastIcon: 'statusOk'
});
export { _default as default };